module.exports = __webpack_public_path__ + "static/laasya-6f88e1eedff2ce0bc11140ab8987e032.jpg";